module.exports = __webpack_public_path__ + "public/img/arrow-b.78f4d42f.svg";